import okta from '../../assets/dir-sync-integration-okta.svg';
import entraId from '../../assets/dir-sync-integration-entra-ID.svg';
import googleWorkspace from '../../assets/dir-sync-integration-google-workspace.svg';
import oneLogin from '../../assets/dir-sync-integration-onelogin.svg';
import jumpCloud from '../../assets/dir-sync-integration-jumpcloud.svg';
import pingFederate from '../../assets/dir-sync-integration-pingfederate.svg';
import cyberArk from '../../assets/dir-sync-integration-cyberark.svg';
import rippling from '../../assets/dir-sync-integration-rippling.svg';

export interface DirectorySyncProvider {
    icon: string;
    label: string;
}

const DIRECTORY_SYNC_PROVIDERS: Record<string, DirectorySyncProvider> = {
    'okta scim v2.0': { icon: okta, label: 'Okta' },
    'azure scim v2.0': { icon: entraId, label: 'Entra ID (Azure AD)' },
    'gsuite directory': { icon: googleWorkspace, label: 'Google Workspace' },
    'onelogin scim v2.0': { icon: oneLogin, label: 'OneLogin' },
    'jump cloud scim v2.0': { icon: jumpCloud, label: 'JumpCloud' },
    'pingfederate scim v2.0': { icon: pingFederate, label: 'PingFederate' },
    'cyberark scim v2.0': { icon: cyberArk, label: 'CyberArk' },
    'rippling scim v2.0': { icon: rippling, label: 'Rippling' },
};

export const directorySyncProvider = (type?: string): DirectorySyncProvider | undefined =>
    type ? DIRECTORY_SYNC_PROVIDERS[type] : undefined;
